import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { deburr, debounce } from 'lodash/fp';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import Autocomplete from 'react-autocomplete';
import SearchIcon from 'components/icons/Search.com.svg';
import mapStateToProps from './mapStateToProps';
import * as actions from './actions';

import cn from './styles.local.less';

const AUTOCOMPLETE_FETCH_INTERVAL = 150;

class FuzzySearchWidget extends PureComponent {
  static propTypes = {
    suggestions: PropTypes.array,
    searchQueryChanged: PropTypes.func,
    searchQuerySelected: PropTypes.func,
  };

  constructor(...args) {
    super(...args);

    this.handleSearchQueryChange = debounce(
      AUTOCOMPLETE_FETCH_INTERVAL,
      this.handleSearchQueryChange,
    );
  }

  state = {
    value: '',
  };

  handleInputChange = (e) => {
    const { value } = e.target;

    this.setState({ value }, () => {
      this.handleSearchQueryChange(value);
    });
  };

  handleSearchQueryChange = (value) => {
    const { searchQueryChanged } = this.props;

    searchQueryChanged(value);
  };

  handleSelectItem = (value) => {
    const { searchQuerySelected } = this.props;

    this.setState({ value }, () => {
      searchQuerySelected(value);
    });
  };

  handleValueFiltering = (item, value) => {
    const valueToFilter = deburr(value.toLowerCase());
    const { label } = item;

    return deburr(label.toLowerCase()).indexOf(valueToFilter) !== -1;
  };

  renderInput = (props) => {
    return (
      <input
        className={cn.inputField}
        {...props}
        placeholder={__('fuzzySearchWidget.placeholder')}
      />
    );
  };

  renderMenu = (items) => {
    return (
      <div className={cns(cn.menu, { hidden: !items.length })}>{items}</div>
    );
  };

  renderItem(item, isHighlighted) {
    return (
      <div
        key={item.value}
        style={{ background: isHighlighted ? '#c9e1eb' : '#fff' }}
      >
        <span className={cn.menuLabel}>{item.label}</span>
      </div>
    );
  }

  renderLabel({ label }) {
    return label;
  }

  render() {
    const { value } = this.state;
    const { suggestions } = this.props;
    const wrapperProps = {
      className: cn.autoCompleteWrapper,
    };

    return (
      <div className={cn.root}>
        <Autocomplete
          getItemValue={this.renderLabel}
          items={suggestions}
          shouldItemRender={this.handleValueFiltering}
          renderInput={this.renderInput}
          renderItem={this.renderItem}
          value={value}
          onChange={this.handleInputChange}
          onSelect={this.handleSelectItem}
          renderMenu={this.renderMenu}
          selectOnBlur
          wrapperProps={wrapperProps}
        />
        <Button bsStyle="primary" className={cn.searchCta}>
          <SearchIcon className={cn.searchIcon} />
        </Button>
      </div>
    );
  }
}

export default connect(mapStateToProps, actions)(FuzzySearchWidget);
